export default __webpack_public_path__ + "static/media/mtt_ovidiuelenes.652fceb0.jpg";